import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import {
	triggerClearMatchDetails,
	triggerFetchMatchDetailsApiCall,
	triggerTxnStatusApiCallSuccess,
} from 'redux/actions';
import { TRIGGER_TXN_STATUS_API_CALL } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { ChangeHistory, CleverTapEvent, CleverTapEventNames } from 'utils';

function* triggerTxnStatusApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const TXN_ID = data['txnId'];
	const PATH = data['path'];
	const ACTION = data['action'] || 'push';
	const pLLimitReducedModalVisibility = data['pLLimitReducedModalVisibility'];
	const STATE_PARAMS = { checkRewards: true, pLLimitReducedModalVisibility: pLLimitReducedModalVisibility };

	yield put(triggerTxnStatusApiCallSuccess());
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.TXN_STATUS + API_CONSTANT.QUERY_PARAMS.TXN_ID + TXN_ID,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching transaction',
			start_index: 0,
			range: 8,
			second_message: 'details',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			if (localStorage.getItem('txn') === 'true') {
				yield put(triggerClearMatchDetails());
				yield put(
					triggerFetchMatchDetailsApiCall(
						{
							txnId: TXN_ID,
						},
						null,
						stopLoader,
					),
				);
			}
			callback && callback(apiData);
			if (apiData?.paymentStatus === 'SUCCESS' || apiData?.status === 'SUCCESS') {
				const eventParams = [
					`txnId: ${apiData?.txnId}`,
					`amount: ${apiData?.amount}`,
					`cashbackAmount: ${apiData?.cashbackAmount}`,
					`cashbackTier: ${apiData?.cashbackTier}`,
					`merchantName: ${apiData?.merchantName}`,
					`status: ${apiData?.paymentStatus}`,
					`txnMode: ${apiData?.txnMode}`,
					`txnSubType: ${apiData?.txnSubType}`,
					`txnTime: ${apiData?.txnTime}`,
					`af_revenue: ${apiData?.amount}`,
					`impsCharge: ${apiData?.impsCharge}`,
				];
				if (store.getState().txnList?.statement_details?.length === 0) {
					CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.FIRST_TRANSACTION_SUCCESS, eventParams);
				}
				CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.TRANSACTION_SUCCESS, eventParams);
			}
			apiData['path'] = PATH;
			!stopLoader && ChangeHistory(ACTION, `/transaction-status`, STATE_PARAMS);
			if (!apiData?.parentTxn) {
				apiData['parentTxn'] = null;
			}
			yield put(triggerTxnStatusApiCallSuccess(apiData));
		}
	}
}

export default function* triggerTxnStatusApiCallSaga() {
	yield takeEvery(TRIGGER_TXN_STATUS_API_CALL, triggerTxnStatusApiCall);
}
